import React from "react";
import { engines } from "./data/config";

const Engine = ({ selectedEngine, selectEngine }) => {
    const [engineDescription, updateEngineDescription] = React.useState('');

    const handleSelectEngine = (engine) => () => {
        selectEngine(engine);
    }

    const handleHover = (engine) => () => {
        updateEngineDescription(engine.description);
    }
    
    return (
        <div className='space-y-2 group/section'>
            <h2 className='section-title'>Engine</h2>
            <div className='grid grid-cols-5 gap-0'>
                {engines.map((engine) => {
                    return <div key={engine.name} className="group flex flex-col items-center justify-center p-2 gap-y-2 cursor-pointer" onClick={handleSelectEngine(engine)} onMouseEnter={handleHover(engine)}>
                        <div className="aspect-square">
                            <img src={`./images/Engine_Icons/TATC_Config_Engine_${engine.prefix}.png`} alt={engine.name} />
                        </div>
                        <h3 className={`${engine.id === selectedEngine.id ? 'bg-tan-300 !text-white' : 'group-hover:bg-gray-200'} selection-title duration-300 px-3 py-2 rounded-md`}>{engine.name}</h3>
                    </div>
                })}
            </div>
            <div className="group-hover/section:opacity-100 group-hover/section:max-h-96 max-h-0 opacity-0 duration-300 overflow-hidden">
                <p className="text-base leading-8 text-slate-500">{engineDescription}</p>
            </div>
        </div>
    )
}

export default Engine;